import { render, staticRenderFns, recyclableRender, components } from "./uni-number-box.vue?vue&type=template&id=dd94a2a8&"
var renderjs
import script from "./uni-number-box.vue?vue&type=script&lang=js&"
export * from "./uni-number-box.vue?vue&type=script&lang=js&"
import style0 from "./uni-number-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-number-box/components/uni-number-box/uni-number-box.vue"
export default component.exports